import { createSlice } from "@reduxjs/toolkit";
import { rowsPerPageJsonData } from "../utils/JsonData";
import moment from "moment";

const initialState = {
  productTypesList: [],
  productTypeDetail: null,
  posTableList: [],
  refreshTable: false,
  posKitchenTypesList: [],
  refreshKitchenTypes: false,
  visitorSaleListKitchen: [],
  kitchenTypesKitchen: [],
  productValueKitchen: 0,
  datasalesList: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  saleSearchFilters: {
    searchText: "",
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().endOf("month").format("YYYY-MM-DD"),
  },
  visitordatasalesList: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  visitorsaleSearchFilters: {
    searchText: "",
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().endOf("month").format("YYYY-MM-DD"),
  },
  vendorsDataGridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  poOrderDataGridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  poOrderMainDataGridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  productsDataGridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  productsSearchFilters: {
    searchText: "",
  },
  inventoryItemsDataGridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  inventoryItemsSearchFilters: {
    searchText: "",
  },
  inventoryTypesDataGridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  inventoryTypesSearchFilters: {
    searchText: "",
  },
  inventoryConsumptionRulesDataGridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  inventoryConsumptionRulesSearchFilters: {
    searchText: "",
  },
  inventoryManagementDataGridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  inventoryManagementSearchFilters: {
    searchText: "",
    startDate: moment().subtract(7, "days").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  },
  productTypesDataGridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  productTypesSearchFilters: {
    searchText: "",
  },
  addOnDataGridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  addOnSearchFilters: {
    searchText: "",
  },
  posTableDataGridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  posTableSearchFilters: {
    searchText: "",
  },
  kitchenDataGridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  kitchenSearchFilters: {
    searchText: "",
  },
  stockDataGridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  stockSearchFilters: {
    startDate: moment().subtract(7, "days").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  },
  dashboardStats: {
    netSell: 0,
    tax: 0,
    transactions: 0,
    Customers: 0,
    Discount: 0,
    Refunds: 0,
    cogs: 0,
    splh: 0,
  },
  kitchenTypes: [],
  kitchenWiseDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  kitchenWiseDatagridPrintOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 100000,
    page: 1,
  },
  kitchenWiseSearchFilters: {
    searchText: "",
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
    kitchen_type: 0,
  },
  categoryTypes: [],
  categoryWiseDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  categoryWiseDatagridPrintOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 100000,
    page: 1,
  },
  categoryWiseSearchFilters: {
    searchText: "",
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
    category_id: 0,
  },
  hourlySalesData: [],
  hourlySalesDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  hourlySalesDatagridPrintOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 100000,
    page: 1,
  },
  hourlySalesSearchFilters: {
    searchText: "",
    startDate: moment().format("YYYY-MM-DD"),
    endTime: moment().endOf("day").format("hh:mm A"),
    startTime: moment().startOf("day").format("hh:mm A"),
  },
  dailySalesDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  dailySalesDatagridPrintOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 100000,
    page: 1,
  },
  dailySalesSearchFilters: {
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  },
  salesSummuryDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  salesSummuryDatagridPrintOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 100000,
    page: 1,
  },
  salesSummurySearchFilters: {
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  },
  inhouseReportDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  inhouseReportDatagridPrintOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 100000,
    page: 1,
  },
  inhouseReportSearchFilters: {
    searchText: "",
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  },
  visitorReportDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  visitorReportDatagridPrintOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 100000,
    page: 1,
  },
  visitorReportSearchFilters: {
    searchText: "",
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  },
  traditionPosTableList: [],
  traditionPosSellInvoiceTableList: [],
  traditionPosTab: 0,
  traditionPosProductTypeList: [],
  traditionPosBookingList: [],
  traditionPosSelectRoomUserList: [],
  traditionPosRoomUserList: [],
  traditionPosProductByTypeList: [],
};

const posSlice = createSlice({
  name: "pos",
  initialState: initialState,
  reducers: {
    productTypesListSuccess: (state, action) => {
      state.productTypesList = action.payload;
    },
    productTypesListFailed: (state, action) => {
      state.productTypesList = [];
    },
    productTypeDetailSuccess: (state, action) => {
      state.productTypeDetail = action.payload;
    },
    productTypeDetailFailed: (state, action) => {
      state.productTypeDetail = null;
    },
    posTableListSuccess: (state, action) => {
      state.posTableList = action.payload;
    },
    posTableListFailed: (state, action) => {
      state.posTableList = [];
    },
    refreshTableSuccess: (state, action) => {
      state.refreshTable = true;
    },
    refreshTableFailed: (state, action) => {
      state.refreshTable = false;
    },
    posKitchenTypesListSuccess: (state, action) => {
      state.posKitchenTypesList = action.payload;
    },
    posKitchenTypesListFailed: (state, action) => {
      state.posKitchenTypesList = [];
    },
    visitorSaleListKitchenSuccess: (state, action) => {
      state.visitorSaleListKitchen = action.payload;
    },
    kitchenTypesKitchenSuccess: (state, action) => {
      state.kitchenTypesKitchen = action.payload;
    },
    productValueKitchenSuccess: (state, action) => {
      state.productValueKitchen = action.payload;
    },
    refreshposKitchenTypesuccess: (state, action) => {
      state.refreshKitchenTypes = true;
    },
    refreshposKitchenTypesFailed: (state, action) => {
      state.refreshKitchenTypes = false;
    },
    datasalesListSuccess: (state, action) => {
      state.datasalesList = {
        ...state.datasalesList,
        [action.payload.key]: action.payload.value,
      };
    },
    saleSearchFiltersSuccess: (state, action) => {
      state.saleSearchFilters = {
        ...state.saleSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    visitordatasalesListSuccess: (state, action) => {
      state.visitordatasalesList = {
        ...state.visitordatasalesList,
        [action.payload.key]: action.payload.value,
      };
    },
    visitorsaleSearchFiltersSuccess: (state, action) => {
      state.visitorsaleSearchFilters = {
        ...state.visitorsaleSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    vendorsDataGridOptionsSuccess: (state, action) => {
      state.vendorsDataGridOptions = {
        ...state.vendorsDataGridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    poOrderDataGridOptionsSuccess: (state, action) => {
      state.poOrderDataGridOptions = {
        ...state.poOrderDataGridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    poOrderMainDataGridOptionsSuccess: (state, action) => {
      state.poOrderMainDataGridOptions = {
        ...state.poOrderMainDataGridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    productsDataGridOptionsSuccess: (state, action) => {
      state.productsDataGridOptions = {
        ...state.productsDataGridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    productsSearchFiltersSuccess: (state, action) => {
      state.productsSearchFilters = {
        ...state.productsSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    inventoryItemsDataGridOptionsSuccess: (state, action) => {
      state.inventoryItemsDataGridOptions = {
        ...state.inventoryItemsDataGridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    inventoryItemsSearchFiltersSuccess: (state, action) => {
      state.inventoryItemsSearchFilters = {
        ...state.inventoryItemsSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    inventoryTypesDataGridOptionsSuccess: (state, action) => {
      state.inventoryTypesDataGridOptions = {
        ...state.inventoryTypesDataGridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    inventoryTypesSearchFiltersSuccess: (state, action) => {
      state.inventoryTypesSearchFilters = {
        ...state.inventoryTypesSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    inventoryConsumptionRulesDataGridOptionsSuccess: (state, action) => {
      state.inventoryConsumptionRulesDataGridOptions = {
        ...state.inventoryConsumptionRulesDataGridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    inventoryConsumptionRulesSearchFiltersSuccess: (state, action) => {
      state.inventoryConsumptionRulesSearchFilters = {
        ...state.inventoryConsumptionRulesSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    inventoryManagementDataGridOptionsSuccess: (state, action) => {
      state.inventoryManagementDataGridOptions = {
        ...state.inventoryManagementDataGridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    inventoryManagementSearchFiltersSuccess: (state, action) => {
      state.inventoryManagementSearchFilters = {
        ...state.inventoryManagementSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    productTypesDataGridOptionsSuccess: (state, action) => {
      state.productTypesDataGridOptions = {
        ...state.productTypesDataGridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    productTypesSearchFiltersSuccess: (state, action) => {
      state.productTypesSearchFilters = {
        ...state.productTypesSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    addOnDataGridOptionsSuccess: (state, action) => {
      state.addOnDataGridOptions = {
        ...state.addOnDataGridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    addOnSearchFiltersSuccess: (state, action) => {
      state.addOnSearchFilters = {
        ...state.addOnSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    posTableDataGridOptionsSuccess: (state, action) => {
      state.posTableDataGridOptions = {
        ...state.posTableDataGridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    posTableSearchFiltersSuccess: (state, action) => {
      state.posTableSearchFilters = {
        ...state.posTableSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    kitchenDataGridOptionsSuccess: (state, action) => {
      state.kitchenDataGridOptions = {
        ...state.kitchenDataGridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    kitchenSearchFiltersSuccess: (state, action) => {
      state.kitchenSearchFilters = {
        ...state.kitchenSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    stockDataGridOptionsSuccess: (state, action) => {
      state.stockDataGridOptions = {
        ...state.stockDataGridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    stockSearchFiltersSuccess: (state, action) => {
      state.stockSearchFilters = {
        ...state.stockSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    dashboardStatsSuccess: (state, action) => {
      state.dashboardStats = action.payload;
    },
    kitchenTypesSuccess: (state, action) => {
      state.kitchenTypes = action.payload;
    },
    kitchenWiseDatagridOptionsSucces: (state, action) => {
      state.kitchenWiseDatagridOptions = {
        ...state.kitchenWiseDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    kitchenWiseDatagridPrintOptionsSucces: (state, action) => {
      state.kitchenWiseDatagridPrintOptions = {
        ...state.kitchenWiseDatagridPrintOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    kitchenWiseSearchFiltersSucces: (state, action) => {
      state.kitchenWiseSearchFilters = {
        ...state.kitchenWiseSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    categoryTypesSuccess: (state, action) => {
      state.categoryTypes = action.payload;
    },
    categoryWiseDatagridOptionsSucces: (state, action) => {
      state.categoryWiseDatagridOptions = {
        ...state.categoryWiseDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    categoryWiseDatagridPrintOptionsSucces: (state, action) => {
      state.categoryWiseDatagridPrintOptions = {
        ...state.categoryWiseDatagridPrintOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    categoryWiseSearchFiltersSucces: (state, action) => {
      state.categoryWiseSearchFilters = {
        ...state.categoryWiseSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    hourlySalesDataSuccess: (state, action) => {
      state.hourlySalesData = action.payload;
    },
    hourlySalesDatagridOptionsSucces: (state, action) => {
      state.hourlySalesDatagridOptions = {
        ...state.hourlySalesDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    hourlySalesDatagridPrintOptionsSucces: (state, action) => {
      state.hourlySalesDatagridPrintOptions = {
        ...state.hourlySalesDatagridPrintOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    hourlySalesSearchFiltersSucces: (state, action) => {
      state.hourlySalesSearchFilters = {
        ...state.hourlySalesSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    dailySalesDatagridOptionsSucces: (state, action) => {
      state.dailySalesDatagridOptions = {
        ...state.dailySalesDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    dailySalesDatagridPrintOptionsSucces: (state, action) => {
      state.dailySalesDatagridPrintOptions = {
        ...state.dailySalesDatagridPrintOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    dailySalesSearchFiltersSucces: (state, action) => {
      state.dailySalesSearchFilters = {
        ...state.dailySalesSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    salesSummuryDatagridOptionsSucces: (state, action) => {
      state.salesSummuryDatagridOptions = {
        ...state.salesSummuryDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    salesSummuryDatagridPrintOptionsSucces: (state, action) => {
      state.salesSummuryDatagridPrintOptions = {
        ...state.salesSummuryDatagridPrintOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    salesSummurySearchFiltersSucces: (state, action) => {
      state.salesSummurySearchFilters = {
        ...state.salesSummurySearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    inhouseReportDatagridOptionsSucces: (state, action) => {
      state.inhouseReportDatagridOptions = {
        ...state.inhouseReportDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    inhouseReportDatagridPrintOptionsSucces: (state, action) => {
      state.inhouseReportDatagridPrintOptions = {
        ...state.inhouseReportDatagridPrintOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    inhouseReportSearchFiltersSucces: (state, action) => {
      state.inhouseReportSearchFilters = {
        ...state.inhouseReportSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    visitorReportDatagridOptionsSucces: (state, action) => {
      state.visitorReportDatagridOptions = {
        ...state.visitorReportDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    visitorReportDatagridPrintOptionsSucces: (state, action) => {
      state.visitorReportDatagridPrintOptions = {
        ...state.visitorReportDatagridPrintOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    visitorReportSearchFiltersSucces: (state, action) => {
      state.visitorReportSearchFilters = {
        ...state.visitorReportSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    traditionPosSellInvoiceTableListSuccess: (state, action) => {
      state.traditionPosSellInvoiceTableList = action.payload;
    },
    traditionPosTableListSuccess: (state, action) => {
      state.traditionPosTableList = action.payload;
    },
    traditionPosTabSuccess: (state, action) => {
      state.traditionPosTab = action.payload;
    },
    traditionPosProductTypeListSuccess: (state, action) => {
      state.traditionPosProductTypeList = action.payload;
    },
    traditionPosBookingListSuccess: (state, action) => {
      state.traditionPosBookingList = action.payload;
    },
    traditionPosSelectRoomUserListSuccess: (state, action) => {
      state.traditionPosSelectRoomUserList = action.payload;
    },
    traditionPosRoomUserListSuccess: (state, action) => {
      state.traditionPosRoomUserList = action.payload;
    },
    traditionPosProductByTypeListSuccess: (state, action) => {
      state.traditionPosProductByTypeList = action.payload;
    },
  },
});

export const {
  productTypesListSuccess,
  productTypesListFailed,
  productTypeDetailSuccess,
  productTypeDetailFailed,
  posTableListSuccess,
  posTableListFailed,
  refreshTableSuccess,
  refreshTableFailed,
  posKitchenTypesListSuccess,
  posKitchenTypesListFailed,
  visitorSaleListKitchenSuccess,
  kitchenTypesKitchenSuccess,
  productValueKitchenSuccess,
  refreshposKitchenTypesuccess,
  refreshposKitchenTypesFailed,
  datasalesListSuccess,
  saleSearchFiltersSuccess,
  visitordatasalesListSuccess,
  visitorsaleSearchFiltersSuccess,
  vendorsDataGridOptionsSuccess,
  poOrderDataGridOptionsSuccess,
  poOrderMainDataGridOptionsSuccess,
  productsDataGridOptionsSuccess,
  productsSearchFiltersSuccess,
  inventoryItemsDataGridOptionsSuccess,
  inventoryItemsSearchFiltersSuccess,
  inventoryTypesDataGridOptionsSuccess,
  inventoryTypesSearchFiltersSuccess,
  inventoryConsumptionRulesDataGridOptionsSuccess,
  inventoryConsumptionRulesSearchFiltersSuccess,
  inventoryManagementDataGridOptionsSuccess,
  inventoryManagementSearchFiltersSuccess,
  productTypesDataGridOptionsSuccess,
  productTypesSearchFiltersSuccess,
  addOnDataGridOptionsSuccess,
  addOnSearchFiltersSuccess,
  posTableDataGridOptionsSuccess,
  posTableSearchFiltersSuccess,
  kitchenDataGridOptionsSuccess,
  kitchenSearchFiltersSuccess,
  stockDataGridOptionsSuccess,
  stockSearchFiltersSuccess,
  dashboardStatsSuccess,
  kitchenWiseDatagridOptionsSucces,
  kitchenWiseDatagridPrintOptionsSucces,
  kitchenWiseSearchFiltersSucces,
  kitchenTypesSuccess,
  categoryTypesSuccess,
  categoryWiseDatagridOptionsSucces,
  categoryWiseDatagridPrintOptionsSucces,
  categoryWiseSearchFiltersSucces,
  hourlySalesDataSuccess,
  hourlySalesDatagridOptionsSucces,
  hourlySalesDatagridPrintOptionsSucces,
  hourlySalesSearchFiltersSucces,
  dailySalesDatagridOptionsSucces,
  dailySalesDatagridPrintOptionsSucces,
  dailySalesSearchFiltersSucces,
  salesSummuryDatagridOptionsSucces,
  salesSummuryDatagridPrintOptionsSucces,
  salesSummurySearchFiltersSucces,
  inhouseReportDatagridOptionsSucces,
  inhouseReportDatagridPrintOptionsSucces,
  inhouseReportSearchFiltersSucces,
  visitorReportDatagridOptionsSucces,
  visitorReportDatagridPrintOptionsSucces,
  visitorReportSearchFiltersSucces,
  traditionPosSellInvoiceTableListSuccess,
  traditionPosTableListSuccess,
  traditionPosTabSuccess,
  traditionPosProductTypeListSuccess,
  traditionPosBookingListSuccess,
  traditionPosSelectRoomUserListSuccess,
  traditionPosRoomUserListSuccess,
  traditionPosProductByTypeListSuccess,
} = posSlice.actions;
export default posSlice.reducer;
